export default {
  "+wet4N": "驗證碼錯誤",
  "2QzYmY": "取消",
  "32AbcK": "選擇公司",
  "4R5GEq": "首頁",
  "9Kfib+": "未知錯誤",
  "9UZxwP": "請輸入驗證碼",
  "9cYMNA": "公司資訊",
  "9ljNkr": "重新發送",
  "9vpYSL": "刪除公司",
  "EWMpn/": "刪除角色",
  FEb7U2: "確認",
  "J3BW/8": "請輸入您email收到的驗證碼",
  "QK/hAI": "檢視權限",
  TqDOFU: "請勿經常發送驗證碼！",
  XeiAal: "刪除",
  aiBGBs: "刪除成功",
  azDNha: "發送成功",
  "e/6XZC": "沒有收到驗證碼？",
  jNxbTC: "驗證碼不能為空",
  l1fZNE: "不可全部取消勾選",
  "2MYr1m": "登入",
  "lzP/we": "下載",
  m0Qdyj: "驗證失敗",
  nJCPaY: "使用者沒有綁定信箱，無法進行驗證",
  x79O39: "是否確定刪除？",
  xxETOY: "公司資料權限配置",
  yGWx2z: "參數錯誤",
  Unvxiq: "切換帳號",
  ggvI6Z: "全選",
  lKbhpS: "裝置可灰階更新時段(本地時間)",
  ayUfs1: "結束時間不能早於開始時間",
  "03eM6t": "200條/頁",
  "7/cUwn": "裝置可更新時段(本地時間)",
  SGDlQ6: "共{total}條",
  "arp+TQ": "50條/頁",
  e8OyHO: "20條/頁",
  iyOrrD: "100條/頁",
  yXsHgv: "10條/頁",
  "+/R6RX": "任務狀態",
  "+0SHNk": "Wi-Fi MAC Address",
  "+4lD9e": "姓名",
  "+74JfZ": "範例：Device_000001_高橋店_Android",
  "+7V2pl": "共",
  "+CLSks": "2. 此命名規則要套用的設備系統類型",
  "+GQdfc": "更新Token",
  "+L9lak": "套用警報模板",
  "+TzicH": "門店",
  "+gbx50": "警報條件",
  "+kHAfa": "請填寫門店詳情",
  "+m8vFq": "命名規則詳情",
  "/8GfsH": "四",
  "/99v4N": "全部門店",
  "/CxA3j": "新增子門店",
  "/Qlgz9": "上傳Windows設備",
  "/SqqyP": "輸入設備序號",
  "/cqdKk": "下載",
  "/sI6h+": "人",
  "0KH9Qi": "設備系統類型",
  "0VK6Tv": "營業狀態",
  "0YYUNG": "已選擇{num}個標籤",
  "0iTEVO": "查看Token",
  "0uRy1k": "一",
  "11uVJ/": "接收物件",
  "19+woq": "門店詳情",
  "1M03Dq": "排程模板",
  "1PtjRr": "設備名稱",
  "1SslIM": "關閉應用",
  "1X8SYs": "經緯度",
  "1sAivX": "Ethernet MAC Address",
  "1sj5Sj": "移除所有本設備套用的排程模版",
  "2/LdaO": "門店配置資訊",
  "2JW1Pt": "請選擇是否同時發送郵件",
  "2nV3tA": "未選擇門店",
  "2opnVU": "執行期間",
  "2qrsN7": "請選擇門店地址",
  "2r/XUW": "移除所有本標籤套用的排程模版",
  "3HzQUc": "導出JSON",
  "3QXG/d": "Ora版本",
  "3XHWMy": "星期四",
  "3aYG4L": "移除設備目前所套用的警報模板，不再監控與發送警報",
  "3h+3Xm": "未開業",
  "3jyOjJ": '是否將所選的設備修改為"已註冊"',
  "3qF993": "您不能轉移不在目前公司的設備。",
  "4/e9qs": "請填寫名稱",
  "4Xdib8": "時段不能為空",
  "4c3uw8": "移出門店",
  "4vWL+W": "導入設備",
  "4wi+/p": "範本",
  "5+oaTO": "image最後更新狀態",
  "5Cm9U3": "訊息通知",
  "5Hy0Qx": "不可轉移到同一門店",
  "5KtG4i": "搜尋企業",
  "5WKL9+": "選擇門店狀態",
  "5jpkHg": "在線狀態",
  "5p8cBO": "帳號管理",
  "5ytYaf": "新增排程模板",
  "6+iYA0": "序號",
  "60Ixlm": "警報模板名稱",
  "6eB+xj": "請選擇指定用戶",
  "6pDRb2": "請輸入有效的密碼",
  "7ip592": "1. 命名規則名稱",
  "88CuCZ": "3. 為註冊在此門店的設備建立命名方式（自動填入設備名稱）",
  "8PESa6": "停用",
  "8huAxo": "新增規則",
  "8u3CYe": "命名規則名稱",
  "8usMqO": "刪除公告",
  "8zN+hZ": "執行應用",
  "9/Vb7e": "上傳裝置",
  "919TK9": "支援格式：xls、xlsx",
  "9AsSO/": "請選擇是否同時發送簡訊",
  "9UefLp": "標籤",
  "9g6s9o": "請填寫門店編碼",
  "9iKk2b": "起始號碼",
  "9r00YD": "公告管理",
  "9w+ho+": "帳號",
  "9yRpjk": "星期六",
  "A/eXwT": "移除所有本標籤套用的警報模版",
  A5kf1W: "全部公司列表",
  ANeFu6: "驗證密碼",
  Abqe2U: "門店地址",
  Axagls: "請選擇結束時間",
  AyWMlZ: "新增排程任務",
  B57Wbu: "未選擇設備",
  BBpRbn: "移除所有本門店套用的警報模版",
  BC74I9: "提示訊息",
  BQcLxf: "下移",
  BYbqwY: "將文件拖曳到此處 或點擊上傳",
  BwXapw: "分類名稱請控制在500字元內",
  C6cGK1: "排程模板名稱不能為空",
  CLqPBU: "編輯",
  CPTAAj: "自然數遞增",
  D5HOUz: "選擇狀態",
  DADacD: "移除所有本門店套用的排程模版",
  DFyP1k: "閉店",
  DxGUhN: "選擇全部設備",
  E1GPl7: "擁有者",
  EGvInA: "設備警報列表",
  EM8lAi: "按公司的設備可更新時段(本地時間)",
  "EO+Nlk": "檔案上傳中，請勿關閉對話框。",
  EwM8Kj: "確定要移出嗎？",
  Ey9rBq: "確定要刪除嗎？",
  F2LJDJ: "確定要移除嗎？",
  F3ndvv: "刪除失敗",
  FBH89G: "修改版本",
  FNIJXx: "請選擇捲動播放",
  "FaJ/jI": "沒有選擇要匯入的文件",
  FbCeo1: "觸發值",
  FbsCUK: "智慧型手機",
  "Fr1I/b": "貼標籤",
  Ft60hS: "Nubis裝置",
  G4XFn6: "硬體型號",
  G4qgGm: "所有用戶",
  G5gg2V: "公告標題為必填",
  G6i1QR: "選擇地址",
  G9APSK: "編輯命名規則",
  Gk0Mt5: "是否確認重設（{name}）該警報設備？重置後警報規則將繼續執行監控。",
  GnzEo7: "image最後更新時間",
  GujK99: "若後續警報模板的內容有更新，也會同步給套用的設備",
  Gwj7xc: "恢復預設",
  H5s58g: "24小時",
  HN1dNJ: "所有帳號",
  HOHQFs: "命名規則名稱不能為空",
  HRXYJB: "全部公司",
  "HdxQ2/": "門店關聯的設定檔與命名規則",
  "Hv/pfB": "星期二",
  I37xbU: "請填寫",
  ITbo35: "門店名稱不能為空!",
  IqkgWZ: "關鍵字",
  "Iwt/8W": "註解",
  "J0D5h+": "開始時間",
  J9jPRL: "複製成功",
  JJl2M9: "匯出",
  JLMIof: "上傳Android設備",
  JRhVym: "營業時間不能為空",
  JeJAmT: "重新命名",
  Jh62y5: "所有設備",
  Jp7u8z: "台",
  KJHvMA: "門店管理",
  KlWMzW: "已啟用",
  Km733q: "請選擇開始時間",
  Kwqd8h: "聯絡人",
  L24ioQ: "標題",
  L80hmc: "公告標題不得超過30字符",
  LNGTru: "設備排程失敗列表",
  LWSLHa: "溫馨提示",
  Lfia0v: "設定排程",
  "LuP+H0": "描述",
  LwhdsE: "切換多選",
  M404r0: "二",
  MZ5Ei7: "時間段和第{num}個時間段有重疊",
  MmsEyp: "註冊",
  MnTdIi: "觸發次數",
  N52KMq: "詳細地址",
  NGs9sO: "返回",
  "NM/lRq": "取消上傳",
  NjB2tN: "請選擇營業狀態!",
  OMcnk6: "Manufactuer",
  OSqnZu: "是否將所選的設備版本改為",
  "OZGX3+": "公告列表",
  OaZpDP: "UUID",
  OcijhH: "主機板序號",
  OsMncl: "未開啟",
  "P/eul9": "否",
  PVmkgT: "請填寫簡稱",
  PaMvre: "警報規則列表",
  PnYplH: "裝置",
  PrIueu: "24h營業",
  "Py/5UG": "操作的節點已不存在，請重新操作",
  "Q+0CDu": "新增命名規則",
  "Q2/NzC": "已選擇{num}台設備",
  QHc9Qg: "公告內容",
  QHhMxE: "選擇角色",
  QLYuf8: "所有公司",
  QV3pnn: "狀態",
  QpOtgZ: "門店名稱",
  Qpcx6F: "公告內容為必填",
  Qpi3DY: "日",
  "QsAe0/": "保存失敗",
  QwHI8Q: "查詢結果：",
  R2D5Dv: "創建時間",
  RCjVsb: "設備ID",
  RNaGVr: "任務失敗列表",
  RQyKsa: "平台公告",
  RWBRyt: "設備分佈地圖建置中",
  RndUeh: "預計執行時間",
  RyXQqJ: "上傳時間",
  S1QSWC: "匯入子門店",
  S57QRB: "Filter by",
  SbZhau: "開機任務需要指定一個開機設備",
  SkK50H: "請新增排程任務",
  SwMBFl: "套用排程模板",
  T3CtvK: "分類名稱不能為空",
  TDSTTj: "選擇排程模板",
  TDuPUp: "已觸發",
  TLZPhr: "星期一",
  TYAJpp: "已選擇{num}個門店",
  UA7mv6: "Ora最後更新時間",
  UBbWUL: "未選擇任何模板",
  UZ49sl: "負責人電話",
  UtE0dS: "操作",
  "Uu/nFu": "移除所有本設備套用的警報模版",
  V0RiZp: "操作成功",
  Vd3wZV: "整體",
  Ve9Ksw: "轉移門店",
  ViVQNi: "角色",
  VqEr9u: "套用門店數",
  Vx4M25: "門店編碼",
  "W/wIZ8": "負責人",
  WYHxWn: "三",
  WYtW9Y: "請選擇一個版本",
  WdyIyo: "運作時長",
  WtPk7v: "同時傳簡訊",
  WxPZOH: "執行{num}次",
  WypzMq: "排程任務",
  Wzv7kF: "請選擇門店",
  X2PYza: "設備詳情",
  "XKj/en": "BIOS序號",
  "XLdI1+": "Wi-Fi強度",
  XMBOec: "移除標籤",
  XPFi6q: "條",
  XmRKnc: "備註",
  YYGRyG: "請上傳附件",
  YeF1dY: "時區",
  YpXN8m: "最後觸發時間",
  YwEzx2: "勾選需要顯示的欄位",
  ZGYHyC: "開始時間不能為空",
  ZQ91U9: "家",
  ZUPzqr: "開啟",
  ZdO12B: "套用門店",
  "Zvt+2g": "倉儲",
  aBleoN: "選擇警報模板",
  aGxRt2: "內容",
  "aN+DgN": "啟動時間",
  akvGrq: "配置規則",
  askOz5: "搜尋地址",
  "b+Dz+s": "全部門店列表",
  b5l2vN: "儲存",
  bBz42a: "更新狀態",
  "bE+h3K": "設備狀態",
  bFBjSK: "五",
  bOKDVF: "切換單選",
  biXcnk: "負責人信箱",
  bqbDVw: "查詢",
  bzfrYI: "公告配置",
  cDZ00w: "查看",
  "cZ9/ZC": "是否刪除[{name}]？",
  cawvIS: "最後更新時間",
  cgIBtg: "選擇上層",
  cr1ymH: "請選擇發送時間",
  "d7i/AT": "上層",
  dEXfrL: "設備健康狀態區間",
  dGBGbt: "全部",
  drCsUI: "公司",
  eAgY2G: "展開子公司",
  eCCa0L: "任務類型",
  "eP/37G": "註冊時間",
  eeCxuz: "OS類型",
  evJP5c: "命名規則",
  f7Dpbl: "下載範本，根據範本提示完善內容",
  "fc12+X": "星期五",
  fz2pkM: "該節點已被刪除",
  gU4eZD: "警報管理",
  gmUXEi: "設備特徵值",
  gnNjS5: "個人設備名稱",
  gpg5DN: "查看公告",
  gplM71: "每日",
  "gyh+d1": "有線網路",
  "h/j3a5": "聯絡人電話",
  h7w4pz: "暫無數據",
  "hD7/Lu": "顯示",
  "hDx3/S": "信箱",
  hEI4G8: "新建公告",
  hYN7oM: "隱藏",
  hkJXyi: "配置排程任務",
  i5MLJc: "最後更新時間：{lastUpdate}",
  "i6kDf/": "選擇裝置中包含{num}台Nubis Free版本，將無法進行裝置指令。",
  iKomBu: "暫無分類",
  iN7Lps: "循環模式",
  ich0wH: "設備SN",
  ifGp4v: "2FA",
  "j/YGZ0": "地圖",
  j3QWSE: "自然數遞增的起始號碼只能為正整數",
  j6m8Si: "聯絡人信箱",
  jAAXdQ: "設備門店",
  jT6zKT: "設備數",
  "jhfb/7": "保存成功",
  js3tZs: "排程模板名稱",
  k7dy8j: "關聯設定檔",
  k9dozc: "執行時間",
  kG2Etz: "網路",
  khyRcw: "請選擇Excel文件",
  "kr+7Iy": "搜尋門店",
  l36W55: "滾動播放",
  lK6HPZ: "請選擇一個門店狀態",
  lVgYx7: "停業",
  lllhRf: "結束時間不能為空",
  loTFGc: "未命名",
  m1h20o: "若後續排程模板的內容有更新，也會同步給套用的設備",
  mFIXSq: "設備序號",
  mKKd1R: "請選擇接收對象",
  "mYa6W/": "自訂文字",
  ma6S6y: "自訂顯示",
  mn0ceu: "有重複的配置規則，請調整",
  "mpeFt+": "報警規則",
  nGubXb: "排程模板詳情",
  nUSeQB: "未選擇帳號",
  nzsNwZ: "設備健康狀態",
  "o+O5d1": "請選擇指派",
  o5OLcm: "門店簡稱",
  o8tJYm: "設備命令",
  o9lryN: "星期日",
  "oFt+cN": "網路測速",
  oW4Uka: "指派",
  obfTaf: "門店配置",
  ojz0Ke: "看更多 >",
  oru5FY: "編輯排程模板",
  "p/3Nn5": "行動網路",
  pBPyFt: "Nubis版本",
  pK94Zd: "匯入門店",
  "pV2t/S": "基本訊息",
  pXEyon: "設備類型",
  peNVzr: "每{num}週",
  peUIwk: "創建公告",
  pfGGi0: "移除裝置目前所套用的排程模板，不再執行",
  pielKO: "開機設備",
  q6qKtH: "查詢條件：",
  q9PHLT: "暫無公告",
  q9YGIf: "營業",
  qDba8m: "離線設備狀態",
  qUKj7E: "複製",
  qUiH5y: "配置規則不能為空",
  "qqwM/t": "設定檔",
  qyh9hz: "營業時間",
  "r0/TUu": "確定",
  "r2dEd/": "重置",
  rAKRwm: "選擇設備版本",
  rDRAr0: "作業系統版本",
  s1l1Jq: "門店和帳戶管理",
  s7NSze: "確認操作前請先輸入您的帳號密碼",
  s9U9qn: "設定警報",
  sGYTej: "休息",
  sOIerB: "未啟用",
  sVsXUO: "星期三",
  sZSyGZ: "啟用",
  srEpKw: "正在上傳",
  srpWCM: "勾選需要顯示的欄位，可拖曳進行排序",
  t5gffJ: "裝置資訊",
  tugHWJ: "返回公告列表",
  u3dVQz: "每週",
  ubuOXs: "已註冊",
  ujBeLh: "維護系統公共通知",
  "uoZwj+": "創建人",
  uuRzdk: "歸屬門店",
  v04auv: "結束時間",
  vD5wnY: "勾選要歸屬的門店，代表擁有該門店的權限",
  vDCwZ9: "上傳文件",
  vr5TVT: "請輸入",
  wOHHSJ: "上移",
  wQAiLI: "重置提醒",
  wYygRu: "送出人",
  "wrU/Kc": "每{num}天",
  x34QXR: "結束時間不可以早於開始時間",
  xI0mPJ: "已開啟",
  xISm1t: "啟用設定",
  xUjLTE: "搜尋",
  xXdMar: "指定用戶",
  xuf2rG: "所有門店",
  xx40g7: "公告標題",
  "y+WxsP": "編輯公告",
  yKFvYY: "同時發送郵件",
  yOMNOj: "是",
  yReEcE: "選擇標籤",
  yb3AuG: "離線",
  ybGQQ3: "無相關結果",
  yc6ZUL: "Ora最後更新狀態",
  ydktLD: "分隔符",
  yeCGlM: "六",
  yfhtRM: "附件",
  ygAHaf: "發送時間",
  yy7EDI: "上傳",
  zftpop: "選擇用戶",
  znuEgQ: "新增營業時間段",
  zok1hp: "C槽",
  zvaxmN: "排程管理",
  zyMKgy: "選擇門店",
  o5QBKU: "成功更新公司",
  "1yM7WW": "是否移除選取的裝置？",
  DqB8kg: "移除裝置",
  QH21BX: "大量註冊設備",
  TlDh4N: "批次刪除設備",
  UcumBq: "警報通知",
  X9zJwr: "批次指派設備",
  lkP6UV: "更新設備",
  wLyMu9: "根據範本提示完善內容",
  FQM81K: "是否將選擇的門店狀態改為",
  WqfGVu: "限制30字以內",
  hV5chR: "請選擇是否彈跳窗",
  vD7UHb: "彈跳窗",
  "0Drg5o": "我同意上述條款",
  "7pY6K/": "條款內容",
  CNkomH: "編輯條款",
  CoaQps: "條款管理",
  "HHA/d7": "條款列表",
  UH1kCc: "新增",
  "VzqtN+": "條款內容為必填",
  hOtsIx: "新建條款",
  ilUpPP: "返回條款清單",
  "j+y4w+": "條款標題為必填",
  j4CmNU: "查看條款",
  jJg298: "條款標題",
  t4lrWD: "條款標題不得超過30字元",
  z7A1Fc: "建立條款",
  "OY+bYK": "確認，以後不再顯示",
  "+d1f6p": "上傳Linux裝置",
  UrM0bR: "認證資訊",
  "+uAolt": "範例：允許使用者輕鬆自訂網站標題、圖示和文本，以獲得個人化的網路體驗",
  "0UAhKu": "例：https://nubiscloud.freshdesk.com/support/home",
  "0h3ZUE": "帳號中心上傳",
  "0lEh3g": "Nubis 空間上傳",
  "0xMj0V": "範例：提供進版或是更新裝置的image",
  "3DMdxJ": "編輯 DeviceCenter 頁籤",
  "4ImW13": "例：門市管理",
  "52LsQF": "例：帳號中心",
  "5BTra1": "例：Platform",
  "61gplm": "文字上傳",
  "6sZvzw": "替換裝置中心關鍵字",
  "7bKyxU": "上傳的圖檔會儲存在nubis drive中的檔案瀏覽，檔案損壞或刪除會導致圖片載入失敗",
  "7q8OJE": "編輯 Platform",
  "8TfVSD": "編輯 Platform 頁籤",
  "8pToBN": "例：Cloud",
  "9/8z30": "允許使用者輕鬆自訂網站標題、圖示和文本，以獲得個人化的網路體驗",
  "9C+wuW": "範例：裝置管理",
  "D1cAYC": "例：裝置中心",
  "FKBH20": "例：Nubis 空間",
  "G+eQYn": "範例：門市和帳戶管理",
  "G2LkOf": "公告管理上傳",
  "I9uxGU": "例：全球服務，創造您的想像力，提供智慧體驗",
  "K1Xqdl": "範例：權限管理",
  "LTVlAP": "升級中心上傳",
  "Q1/SUP": "範例：維護系統公共通知",
  "QAN35o": "範例：管理設備、監控、遠端操控設備等",
  "R8nCNR": "裝置管理上傳",
  "TVuUjT": "Ora",
  "U08bUN": "設備中心上傳",
  "Wu2nnZ": "Platform 介紹",
  "ZP1/uy": "範例：管理Nubis平台角色使用權限",
  "ayjmy+": "範例：管理您在全世界的裝置與群組",
  "bhXvJB": "權限管理上傳",
  "cAIDk5": "支援中心",
  "d3b8dv": "個人化管理上傳",
  "dFHONh": "Nubis",
  "dWy8l5": "例：Ora",
  "fZJ9SZ": "範例：為您的工作夥伴與客戶管理帳號",
  "jAmQmn": "例：Deivce Center",
  "kwx95y": "例：個人化管理",
  "ov96O9": "個人化管理",
  "rM4ciX": "範例：公告管理",
  "uDYj3x": "網址中心",
  "uRrPru": "門市管理上傳",
  "vdUVb9": "例：升級中心",
  "xrKftB": "圖示上傳",
  "2IaM+V": "更新中心",
  "EoXhnk": "設備中心",
  "JeSd9K": "其他",
  "wzIKok": "繼承上級公司的個人化設定",
  "BQDKvZ": "例：Agent",
  "EO9pTF": "例：Cloud",
  "JmnNA0": "選填欄位",
  "LG70v2": "發送訂單記錄",
  "NZQWZL": "正式",
  "PjtWQX": "已選擇 {num} Licenses",
  "Plhuph": "搜尋訂單編號，erp 編號",
  "Rrwy85": "創作者",
  "TX6jKq": "接收",
  "U+pKlD": "是否刪除 訂單編號: {name}？",
  "Xvn+2E": "客戶聯絡人",
  "YII2+w": "失效日期",
  "YJbxtM": "接受公司",
  "ZIJmYm": "訂單管理",
  "ZTs8/J": "建立Licenses",
  "a7AYs5": "有效期間（天）",
  "eM8o1Y": "訂單編號",
  "eUSpdN": "看更多",
  "er7lkB": "金額",
  "fyjje7": "License Key",
  "gqvOsW": "客戶聯絡人",
  "iTiIWl": "沒有符合的資料",
  "k1xuGk": "搜尋訂單編號",
  "kPb1Wj": "ERP編號",
  "lfUbAE": "生效中",
  "mPsm6o": "測試",
  "ouraCD": "裝置管理",
  "pUL1dA": "刪除訂單",
  "pecEGk": "註銷",
  "sTreBL": "實際生效日期",
  "sbThvA": "發送公司",
  "svGx//": "請填入合法的數字",
  "tMGiGt": "License 類型",
  "tsV2n0": "建立訂單",
  "twizE+": "業務信箱",
  "u6rHwS": "訂單產生日期",
  "vePxOp": "正常",
  "wNYTXq": "未使用",
  "wawZXM": "License 狀態",
  "xVTk70": "載入中",
  "xxFsds": "必填欄位",
  "0axARa": "到期時間",
  "0tqhdw": "經理以上等級將收到[{x}]家公司的電子郵件,共有[{y}]家公司。",
  "4DfIa5": "所選的許可證類型不得為測試版",
  "4kc3eS": "每月的第一天，系統將發送一封關於需要通知的許可證或設備狀態的電子郵件。電子郵件包含以下資訊。",
  "7FTqlN": "無匹配 Licenses",
  "AfMAI0": "擁有許可證的設備將在當前許可證到期時自動收到新的許可證",
  "FQjcoc": "License 自動化規則",
  "GDWKlf": "配對裝置SN",
  "Iqlkbs": "所選許可證狀態必須為未使用",
  "K5iYC8": "將在未來100天內達到自動啟動日期的未使用許可證。",
  "NBz0wZ": "目前處於活動狀態但未指派給任何裝置的許可證。",
  "URkpah": "失效 Licenses",
  "UjxKxu": "終止",
  "VaAWfW": "許可證的自動生效日期越近，優先順序越高",
  "Wp2PXY": "通知設定",
  "X2YceA": "未使用 Licenses",
  "ZLqStU": "預先導入的設備在註冊時將自動收到許可證",
  "daUauj": "License Key,訂單編號、配對設備SN",
  "eFFkgE": "License庫存概覽",
  "eHMGvf": "請選擇一個 License",
  "eR85km": "擁有將在未來100天內到期的授權許可證的設備。如果許可證到期且沒有提供替換許可證，則設備將移動到保留狀態。",
  "fTfy0b": "系統將依據許License自化規則自動套用授權",
  "ftSBnR": "配對 License",
  "lLC16+": "License管理",
  "lQGDqR": "已處於保留或掛起狀態的裝置。",
  "lTtEaU": "保留",
  "t0EXqz": "生效中 Licenses",
  "vPHZLC": "含子公司",
  "xy6tQS": "透過OR Code或API註冊的裝置將自動取得授權",
  "zE041n": "過期日期",
  "FQQECq": "必填",
  "ekxzlF": "名稱"
};
